<template>
    <div>
        <div class="container" style="background-color:white">
            <!-- 
            {{person_details}} -->
            <div>
                <center><img src="https://universal-wws-schoolerp.s3.ap-south-1.amazonaws.com/logo/uwws_admission_form_logo.png" style="width: 200px;" alt="logo" /></center>
                <center><h2>UNIVERSAL WISDOM SCHOOL</h2></center>
                <center><h2>ADMISSION FORM</h2></center>
            </div>
            <div>
                <div style="display: flex;">
                    <div style="width: 50%; float: left;">
                            <div class="row">
                                 <h4 style="margin: 10px;">
                                Academic year : &nbsp;
                                  </h4>
                                <div style="width: 50%;" class="decoration">{{ person_details.ay }}</div>
                                 <h4 style="margin: 10px;">
                                Admission No. : &nbsp;
                                 </h4>
                                <div style="width: 50%;" class="decoration">{{ person_details.admission_form_no }}</div>
                                 <h4 style="margin: 10px;">
                                Admission Date : &nbsp;
                                </h4>
                                <div style="width: 50%;" class="decoration"><span v-if="person_details.admission_date=='NA'"></span><span v-else>{{ person_details.admission_date}}</span></div>
                                 <h4 style="margin: 10px;">
                                Grade Applied For : &nbsp;
                                 </h4>
                                <div style="width: 50%;" class="decoration">{{ person_details.standard.field_value }}</div>
                            </div>
                       
                    </div>
                    <div style="width: 75%; float: right;">
                        <div class="photo">
                            <center>
                                <v-img width="190" :src="awspath + person_details.profile_image_path + person_details.profile_image_name" aspect-ratio="1" class="lighten-2" style="border: 2px solid black; border-radius: 10px;"></v-img>
                                Student`s Photo
                            </center>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <h3 style="color: #b04759;">1.Student Details</h3>
            </div>
            <div style="border: 1px solid black; padding: 17px;">
                <div class="row">
                    <div class="col-4 stud_details" style="" v-if="person_details.firstname != null">
                        <b> First Name</b>&nbsp;<br />
                        {{ person_details.firstname.field_value }}
                    </div>
                    <div class="col-4 text-center stud_details" style="" v-if="person_details.middlename != null">
                        <b> Middle Name</b>&nbsp;<br />
                        {{ person_details.middlename.field_value }}
                    </div>
                    <div class="col-4 text-center stud_details" style="" v-if="person_details.lastname != null">
                        <b> Last Name</b>&nbsp;<br />
                        {{ person_details.lastname.field_value }}
                    </div>
                    <div class="col-12 stud_details" v-if="person_details.fullname != null" style=""><b> Full Name:</b>&nbsp; {{ person_details.fullname.field_value }}</div>
                    <div class="col-6" style="" v-if="person_details.date_of_birth != null">
                        <div class="row">
                            <b> {{ person_details.date_of_birth.field_display_name }} : </b>
                            <div style="width: 60%; margin-left: 5px;" class="stud_details2">{{ person_details.date_of_birth.field_value }}</div>
                        </div>
                    </div>
                    <div class="col-6" style="" v-if="person_details.gender != null">
                        <div class="row">
                            <b> {{ person_details.gender.field_display_name }} : </b>
                            <div style="width: 84%; margin-left: 5px;" class="stud_details2">{{ person_details.gender.field_value }}</div>
                        </div>
                    </div>
                    <div class="col-12" style="" v-if="person_details.date_of_birth_in_words != null">
                        <div class="row">
                            <b> {{ person_details.date_of_birth_in_words.field_display_name }} : </b>
                            <div style="width: 81%; margin-left: 5px;" class="stud_details2">{{ person_details.date_of_birth_in_words.field_value }}</div>
                        </div>
                    </div>
                    <div class="col-4" style="" v-if="person_details.birthcity != null">
                        <div class="row">
                            <b> Birth Place : {{ person_details.birthcity.field_display_name }} :</b>
                            <div style="width: 55%; margin-left: 5px;" class="stud_details2">{{ person_details.birthcity.field_value }}</div>
                        </div>
                    </div>
                    <div class="col-4" style="" v-if="person_details.birthstate != null">
                        <div class="row">
                            <b> {{ person_details.birthstate.field_display_name }} :</b>
                            <div style="width: 70%; margin-left: 5px;" class="stud_details2">{{ person_details.birthstate.field_value }}</div>
                        </div>
                    </div>
                    <div class="col-4" style="" v-if="person_details.birthcountry != null">
                        <div class="row">
                            <b> {{ person_details.birthcountry.field_display_name }} :</b>
                            <div style="width: 75%; margin-left: 5px;" class="stud_details2">{{ person_details.birthcountry.field_value }}</div>
                        </div>
                    </div>
                    <div class="col-4" style="" v-if="person_details.nationality != null">
                        <div class="row">
                            <b> {{ person_details.nationality.field_display_name }} : </b>
                            <div style="width: 70%; margin-left: 5px;" class="stud_details2">{{ person_details.nationality.field_value }}</div>
                        </div>
                    </div>
                     <div class="col-4" style="" v-if="person_details.religion != null">
                        <div class="row">
                            <b> {{ person_details.religion.field_display_name }} : </b>
                            <div style="width: 75%; margin-left: 5px;" class="stud_details2">{{ person_details.religion.field_value }}</div>
                        </div>
                    </div>
                    <div class="col-4" style="" v-if="person_details.citizenship != null">
                        <div class="row">
                            <b> {{ person_details.citizenship.field_display_name }} : </b>
                            <div style="width: 65%; margin-left: 5px;" class="stud_details2">{{ person_details.citizenship.field_value }}</div>
                        </div>
                    </div>
                    <div class="col-4" style="" v-if="person_details.cast != null">
                        <div class="row">
                            <b> {{ person_details.cast.field_display_name }} : </b>
                            <div style="width: 78%; margin-left: 5px;" class="stud_details2">{{ person_details.cast.field_value }}</div>
                        </div>
                    </div>
                    <div class="col-4" style="" v-if="person_details.category != null">
                        <div class="row">
                            <b> {{ person_details.category.field_display_name }} : </b>
                            <div style="width: 70%; margin-left: 5px;" class="stud_details2">{{ person_details.category.field_value }}</div>
                        </div>
                    </div>
                    <div class="col-4" style="" v-if="person_details.sub_caste != null">
                        <div class="row">
                            <b> {{ person_details.sub_caste.field_display_name }} : </b>
                            <div style="width: 78%; margin-left: 5px;" class="stud_details2">{{ person_details.sub_caste.field_value }}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6" style="" v-if="person_details.passport_no != null">
                        <div class="row">
                            <b> {{ person_details.passport_no.field_display_name }} : </b>
                            <div style="width: 70%; margin-left: 5px;" class="stud_details2">{{ person_details.passport_no.field_value }}</div>
                        </div>
                    </div>
                    <div class="col-6" style="" v-if="person_details.aadhar_no != null">
                        <div class="row">
                            <b> {{ person_details.aadhar_no.field_display_name }} : </b>
                            <div style="width: 70%; margin-left: 5px;" class="stud_details2">{{ person_details.aadhar_no.field_value }}</div>
                        </div>
                    </div>
                    <div class="col-6" style="" v-if="person_details.mothertoungue != null">
                        <div class="row">
                            <b> {{ person_details.mothertoungue.field_display_name }} : </b>
                            <div style="width: 68%; margin-left: 5px;" class="stud_details2">{{ person_details.mothertoungue.field_value }}</div>
                        </div>
                    </div>
                    <div class="col-6" style="" v-if="person_details.second_language_currently_studying != null">
                        <div class="row">
                            <b> {{ person_details.second_language_currently_studying.field_display_name }} : </b>
                            <div style="width: 40%; margin-left: 5px;" class="stud_details2">{{ person_details.second_language_currently_studying.field_value }}</div>
                        </div>
                    </div>
                    <div class="col-12" style="" v-if="person_details.languages_known != null">
                        <div class="row">
                            <b> {{ person_details.languages_known.field_display_name }} : </b>
                            <div v-if="person_details.languages_known.field_value" v-for="index in 3" :key="index" style="width: 25%; margin-left: 5px;" class="stud_details2">
                                <span v-if="index ==1">{{index}}. {{person_details.languages_known.field_value[0]}} </span>
                                <span v-else-if="index ==2"> {{index}}. {{person_details.languages_known.field_value[1]}} </span>
                                 <span v-else>{{index}}. {{person_details.languages_known.field_value[2]}} </span>
                            </div>
                            <div v-else style="width: 25%; margin-left: 5px;" class="stud_details2">{{index}}.</div>
                        </div>
                    </div>
                    <div class="col-6" style="" v-if="person_details.special_education_needs != null">
                        <div class="row">
                            <b> Special Education Needs : </b>
                                <div v-if="person_details.special_education_needs.field_value" style="width: 55%; margin-left: 5px;" class="stud_details2"> Yes</div>
                                <div v-else style="width: 55%; margin-left: 5px;" class="stud_details2">No</div>
                        </div>
                    </div>
                    <div class="col-6" style="" v-if="person_details.special_education_needs != null">
                        <div class="row" v-if="person_details.special_education_needs.field_value">
                            <b> If yes,kindly specify:  </b>
                                <div style="width: 65%; margin-left: 5px;" class="stud_details2">{{ person_details.special_education_needs.field_value }}</div>
                        </div>
                    </div>
                    <div class="col-12" style="" v-if="person_details.previous_school_name != null">
                        <div class="row">
                            <b> Last School attended : </b>
                            <div style="width: 82%; margin-left: 5px;" class="stud_details2">{{ person_details.previous_school_name.field_value }}</div>
                        </div>
                    </div>
                    <div class="col-6" style="" v-if="person_details.academic_program_studied != null">
                        <div class="row">
                            <b> {{ person_details.academic_program_studied.field_display_name }} : </b>
                            <div style="width: 45%; margin-left: 5px;" class="stud_details2"><span v-if="person_details.academic_program_studied.field_value"> {{ person_details.academic_program_studied.field_value }} </span></div>
                        </div>
                    </div>
                    <div class="col-6" style="" v-if="person_details.previousschoolpassingstandard != null">
                        <div class="row">
                            <b> Last Grade Attended : </b>
                            <div style="width: 65%; margin-left: 5px;" class="stud_details2"><span v-if="person_details.previousschoolpassingstandard.field_value"> {{person_details.previousschoolpassingstandard.field_value }}</span></div>
                        </div>
                    </div>
                    <div class="col-12" style="" v-if="person_details.reason_for_leaving_last_school != null">
                        <div class="row">
                            <b> Reason for Transfer / Withdrawal : </b>
                            <div style="width: 73%; margin-left: 5px;" class="stud_details2">{{ person_details.reason_for_leaving_last_school.field_value }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 pagebreak">
                <br>
                <h3 style="color: #b04759;">2. Parent / Guardian Details</h3>
                <v-row dense>
                     <b>Father :</b>
                    <v-col cols="12" sm="12" md="12">
                        <v-row dense>
                            Name :
                            <div style="width: 94%; margin-left: 5px;" class="stud_details2">{{ person_details.relative_father_details.relative_full_name }}</div>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-row dense>
                            Educational Qualification :
                            <div style="width: 55%; margin-left: 5px;" class="stud_details2">
                                {{ person_details.relative_father_details.relative_education }}
                            </div>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-row dense>
                            Aadhar No.:
                            <div style="width: 80%; margin-left: 5px;" class="stud_details2">
                                {{ person_details.relative_father_details.relative_aadharno }}
                            </div>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-row dense>
                            Passport No.:
                            <div style="width: 80%; margin-left: 5px;" class="stud_details2">
                                {{ person_details.relative_father_details.relative_passportno }}
                            </div>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="9" md="9" class="pt-none mt-none">
                        <v-row dense>
                            <v-col cols="12" sm="6" md="6" class="pt-none mt-none">
                                <v-row dense class="pt-none mt-none">
                                    Occupation :
                                    <div style="width: 65%; margin-left: 5px;" class="stud_details2">
                                        {{ person_details.relative_father_details.relative_occupation }}
                                    </div>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="pt-none mt-none">
                                <v-row dense class="pt-none mt-none">
                                    Designation :
                                    <div style="width: 72%; margin-left: 5px;" class="stud_details2">
                                        {{ person_details.relative_father_details.relative_designation }}
                                    </div>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-row dense class="pt-none mt-none">
                                    Organisation :
                                    <div style="width: 85%; margin-left: 5px;" class="stud_details2">{{ person_details.relative_father_details.relative_organization_name }}</div>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="pt-none mt-none">
                                <v-row dense class="pt-none mt-none">
                                    Phone :
                                    <div style="width: 75%; margin-left: 5px;" class="stud_details2">
                                        {{ person_details.relative_father_details.relative_phone_no }}
                                    </div>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="pt-none mt-none">
                                <v-row dense class="pt-none mt-none">
                                    Mobile No. :
                                    <div style="width: 73%; margin-left: 5px;" class="stud_details2">
                                        {{ person_details.relative_father_details.relative_contact_no }}
                                    </div>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-row dense class="pt-none mt-none">
                                    Email ID :
                                    <div style="width: 89%; margin-left: 5px;" class="stud_details2">{{ person_details.relative_father_details.relative_email }}</div>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-row dense class="pt-none mt-none">
                                    Address:
                                    <div style="width: 89%; margin-left: 5px;" class="stud_details2">{{ person_details.relative_father_details.relative_local_address }}</div>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <div class="photo">
                            <center>
                                <v-img width="190" :src="awspath + person_details.father_photo" aspect-ratio="1" class="lighten-2" style="border: 2px solid black; border-radius: 10px;"></v-img>
                                Father`s Photo
                            </center>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                        <v-row dense>
                            <v-col cols="12" sm="2" md="2">
                            Permanent Address :
                            </v-col>
                             <v-col cols="12" sm="9" md="9">
                            <!-- <div style="width: 80%; margin-left: 5px;" class="stud_details2">{{ person_details.relative_father_details.relative_permanent_address }}</div> -->
                            {{ person_details.relative_father_details.relative_permanent_address }}
                            <hr style="width: 100%; border-bottom: 1px solid #706F6F;" />
                             </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                  <v-row dense>
                    <b>Mother :</b>
                    <v-col cols="12" sm="12" md="12">
                        <v-row dense>
                            Name :
                            <div style="width: 94%; margin-left: 5px;" class="stud_details2">{{ person_details.relative_mother_details.relative_full_name }}</div>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-row dense>
                            Educational Qualification :
                            <div style="width: 55%; margin-left: 5px;" class="stud_details2">
                                {{ person_details.relative_mother_details.relative_education }}
                            </div>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-row dense>
                            Aadhar No.:
                            <div style="width: 80%; margin-left: 5px;" class="stud_details2">
                                {{ person_details.relative_mother_details.relative_aadharno }}
                            </div>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-row dense>
                            Passport No.:
                            <div style="width: 80%; margin-left: 5px;" class="stud_details2">
                                {{ person_details.relative_mother_details.relative_passportno }}
                            </div>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="9" md="9" class="pt-none mt-none">
                        <v-row dense>
                            <v-col cols="12" sm="6" md="6" class="pt-none mt-none">
                                <v-row dense class="pt-none mt-none">
                                    Occupation :
                                    <div style="width: 65%; margin-left: 5px;" class="stud_details2">
                                        {{ person_details.relative_mother_details.relative_occupation }}
                                    </div>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="pt-none mt-none">
                                <v-row dense class="pt-none mt-none">
                                    Designation :
                                    <div style="width: 72%; margin-left: 5px;" class="stud_details2">
                                        {{ person_details.relative_mother_details.relative_designation }}
                                    </div>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-row dense class="pt-none mt-none">
                                    Organisation :
                                    <div style="width: 85%; margin-left: 5px;" class="stud_details2">{{ person_details.relative_mother_details.relative_organization_name }}</div>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="pt-none mt-none">
                                <v-row dense class="pt-none mt-none">
                                    Phone :
                                    <div style="width: 75%; margin-left: 5px;" class="stud_details2">
                                        {{ person_details.relative_mother_details.relative_phone_no }}
                                    </div>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="pt-none mt-none">
                                <v-row dense class="pt-none mt-none">
                                    Mobile No. :
                                    <div style="width: 73%; margin-left: 5px;" class="stud_details2">
                                        {{ person_details.relative_mother_details.relative_contact_no }}
                                    </div>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-row dense class="pt-none mt-none">
                                    Email ID :
                                    <div style="width: 89%; margin-left: 5px;" class="stud_details2">{{ person_details.relative_mother_details.relative_email }}</div>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-row dense class="pt-none mt-none">
                                    Address:
                                    <div style="width: 89%; margin-left: 5px;" class="stud_details2">{{ person_details.relative_mother_details.relative_local_address }}</div>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <div class="photo">
                            <center>
                                <v-img width="190" :src="awspath + person_details.mother_photo" aspect-ratio="1" class="lighten-2" style="border: 2px solid black; border-radius: 10px;"></v-img>
                                Mother`s Photo
                            </center>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                        <v-row dense>
                            <v-col cols="12" sm="2" md="2">
                            Permanent Address :
                            </v-col>
                            <v-col cols="12" sm="9" md="9">
                            <!-- <div style="width: 80%; margin-left: 5px;" class="stud_details2">{{ person_details.relative_mother_details.relative_permanent_address }}</div> -->
                               {{ person_details.relative_mother_details.relative_permanent_address }}
                                <hr style="width: 100%; border-bottom: 1px solid #706F6F;" />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                  <v-row dense>
                    <b>Guardian :</b>
                    <v-col cols="12" sm="12" md="12" v-if="person_details.emergency_contact_name">
                        <v-row dense>
                            Name :
                            <div style="width: 94%; margin-left: 5px;" class="stud_details2">{{ person_details.emergency_contact_name.field_value }}</div>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" v-if="person_details.emergency_qualification">
                        <v-row dense>
                            Educational Qualification :
                            <div style="width: 55%; margin-left: 5px;" class="stud_details2">
                                {{ person_details.emergency_qualification.field_value }}
                            </div>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" v-if="person_details.emergency_aadhar_no">
                        <v-row dense>
                            Aadhar No.:
                            <div style="width: 80%; margin-left: 5px;" class="stud_details2">
                                {{ person_details.emergency_aadhar_no.field_value }}
                            </div>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="9" md="9" class="pt-none mt-none">
                        <v-row dense>
                            <v-col cols="12" sm="6" md="6" class="pt-none mt-none" v-if="person_details.emergency_occupation">
                                <v-row dense class="pt-none mt-none">
                                    Occupation :
                                    <div style="width: 65%; margin-left: 5px;" class="stud_details2">
                                        {{ person_details.emergency_occupation.field_value }}
                                    </div>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="pt-none mt-none" v-if="person_details.emergency_designation">
                                <v-row dense class="pt-none mt-none">
                                    Designation :
                                    <div style="width: 72%; margin-left: 5px;" class="stud_details2">
                                        {{ person_details.emergency_designation.field_value }}
                                    </div>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-row dense class="pt-none mt-none" v-if="person_details.emergency_company_name">
                                    Organisation :
                                    <div style="width: 85%; margin-left: 5px;" class="stud_details2">{{ person_details.emergency_company_name.field_value }}</div>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="pt-none mt-none" v-if="person_details.emergency_phone_number">
                                <v-row dense class="pt-none mt-none">
                                    Phone :
                                    <div style="width: 75%; margin-left: 5px;" class="stud_details2">
                                        {{ person_details.emergency_phone_number.field_value }}
                                    </div>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="pt-none mt-none" v-if="person_details.emergency_contact_number">
                                <v-row dense class="pt-none mt-none">
                                    Mobile No. :
                                    <div style="width: 73%; margin-left: 5px;" class="stud_details2">
                                        {{ person_details.emergency_contact_number.field_value }}
                                    </div>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" v-if="person_details.emergency_email">
                                <v-row dense class="pt-none mt-none">
                                    Email ID :
                                    <div style="width: 89%; margin-left: 5px;" class="stud_details2">{{ person_details.emergency_email.field_value }}</div>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" v-if="person_details.emergency_contact_address">
                                <v-row dense class="pt-none mt-none">
                                    Address:
                                    <div style="width: 89%; margin-left: 5px;" class="stud_details2">{{ person_details.emergency_contact_address.field_value }}</div>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <div class="photo">
                            <center>
                                <v-img width="190" :src="awspath + person_details.guardian_photo" aspect-ratio="1" class="lighten-2" style="border: 2px solid black; border-radius: 10px;"></v-img>
                                Guardian`s Photo
                            </center>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" v-if="person_details.emergency_contact_permanent_address">
                        <v-row dense>
                            <v-col cols="12" sm="2" md="2">
                            Permanent Address :
                            </v-col>
                            <v-col cols="12" sm="9" md="9">
                            <!-- <div style="width: 80%; margin-left: 5px;" class="stud_details2">{{ person_details.emergency_contact_permanent_address.field_value }}</div> -->
                           {{ person_details.emergency_contact_permanent_address.field_value }}
                            <hr style="width: 100%; border-bottom: 1px solid #706F6F;" />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </div>

            <div class="pagebreak">
                <div class="declaration_details">
                    <div class="row" v-if="person_details.preferred_communication_address">
                        <h3 style="color: #b04759;">Preferred Communication Address:</h3>
                        <div class="col-12" v-if="person_details.preferred_communication_address">
                            <div class="row">
                                Communication same as
                                <div style="width: 15%; margin-left: 5px;" class="stud_details1"><span v-if="person_details.preferred_communication_address">{{person_details.preferred_communication_address.field_value}}</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="person_details.sibling1 != null">
                        <h3 style="color: #b04759;">3.Sibling Details</h3>
                    </div>
                    <div class="row" v-if="person_details.sibling1 != null">
                        <div class="col-6">
                            <div class="row">
                                <b>Name : </b>
                                <div style="width: 85%; margin-left: 5px;" class="stud_details1">{{ person_details.sibling1.sibling_name }}</div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="row">
                                <b>Age : </b>
                                <div style="width: 89%; margin-left: 5px;" class="stud_details1">{{person_details.sibling1.age}}</div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="row">
                                <b>School Name : </b>
                                <div style="width: 85%; margin-left: 5px;" class="stud_details1">{{ person_details.sibling1.name_of_school }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <!-- <h4 style="color: #b04759;">{{person_details.specific_qualities.field_display_name}}</h4> -->
                        <h3 style="color: #b04759;">4. Special qualities or any other information about your child that you may wish to share with us :</h3>
                    </div>
                    <div class="row" v-if="person_details.specific_qualities.field_value">
                         {{person_details.specific_qualities.field_value}}
                         <hr style="width: 270%; border-bottom: 1px solid #706F6F;" />
                    </div>
                    <div v-else>
                        <div style="width: 100%; margin-left: 5px; margin-top: 15px;" class="stud_details1 row"></div>
                        <div style="width: 100%; margin-left: 5px; margin-top: 15px;" class="stud_details1 row"></div>
                        <div style="width: 100%; margin-left: 5px; margin-top: 15px;" class="stud_details1 row"></div>
                        <div style="width: 100%; margin-left: 5px; margin-top: 15px;" class="stud_details1 row"></div>
                    </div>
                    <div class="row" v-if="person_details.allergy!= null">
                        <!-- <h3 style="color: #b04759;">5. History of any significant past or present prolonged illness .Eg.Epilepsy , asthma , any other</h3> -->
                        <h3 style="color: #b04759;">5. {{person_details.allergy.field_display_name}}</h3>
                    </div>
                    <div class="row" v-if="person_details.allergy.field_value != null">
                         {{person_details.allergy.field_value}}
                         <hr style="width: 270%; border-bottom: 1px solid #706F6F;" />
                    </div>
                    <div v-else>
                        <div style="width: 100%; margin-left: 5px; margin-top: 15px;" class="stud_details1 row"></div>
                        <div style="width: 100%; margin-left: 5px; margin-top: 15px;" class="stud_details1 row"></div>
                    </div>
                    <div class="row">
                        <h3 style="color: #b04759;">6. Any other significant information that you may wish to share with us.</h3>
                    </div>
                    <div class="row" v-if="person_details.significant_information">
                         {{person_details.significant_information.field_value}} 
                         <hr style="width: 270%; border-bottom: 1px solid #706F6F;" />
                    </div>
                    <div v-else>
                        <div style="width: 100%; margin-left: 5px; margin-top: 15px;" class="stud_details1 row"></div>
                        <div style="width: 100%; margin-left: 5px; margin-top: 15px;" class="stud_details1 row"></div>
                    </div>
                
                <div class="row" style="text-align: justify;" v-if="person_details.admission_instruction != null">
                    <!-- <div v-if="person_details.admission_instruction.admission_instructions_html_code != null">
                        <div  v-html="person_details.admission_instruction.admission_instructions_html_code"></div>
                    </div> -->
                    Disclaimer : I certify that the information I have given on the admission form is complete and correct . I understand my failure to provide complete , accurate and truthful information on the admission form will be
                    grounds to deny or withdraw my admission or dismiss me after enrollment. I agree to allow the school to utilize the information provided for school related purpose only
                </div>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <div class="row justify-center">
                    <pre>
                        ___________________       ___________________      _____________________ 
                        Father`s Signature        Mother`s Signature       Guardian`s Signature                     
                    </pre>
                </div>
            </div>
            </div>
            
            <div class="row pagebreak">
                <!-- <div v-if="person_details.admission_instruction.admission_checklist_html_code != null">
                        <div v-html="person_details.admission_instruction.admission_checklist_html_code"></div>
                    </div> -->
                <div class="col-12">
                    <center>
                        <h3><u>ADMISSION CHECKLIST</u></h3>
                    </center>
                </div>
                <div class="row">
                    <div class="col-12">
                        <h3><u>For Applicant :</u></h3>
                    </div>
                </div>
                <div class="col-12">
                    <ol>
                        <li>Passport size photograph of the student.</li>
                        <li>Photocopy of date of birth certificate or passport.</li>
                        <li>Photocopy of visa and FRRO ( For International students only).</li>
                        <li>Last two / one year (s) academic report (For grade 1 and above )</li>
                        <li>Certificate of merit ( if any)</li>
                        <li>Transfer certificate ( T.C ) Or Leaving certificate</li>
                        <li>Vaccination record or medical certificate</li>
                        <li>Photocopy of Aadhar card</li>
                    </ol>
                </div>
                <div class="row">
                    <div class="col-12">
                        <h3><u>For Parents :</u></h3> 
                    </div>
                </div>
                <div class="col-12">
                    <ol>
                        <li>2 passport size photographs of each parent</li>
                        <li>Photocopies of passport , visa , FRRO (For international passport holders only )</li>
                        <li>Copy of residential proof</li>
                        <li>Application form completely filled, duly signed by both the parents</li>
                        <li>Transport request form ( if availing transport )</li>
                        <li>Photocopy of Aadhar card</li>
                    </ol>
                </div>
            </div>
            <div class="container">
                <div class="text-center">
                    <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()" v-if="person_details != null">
                        <v-icon left>mdi-printer</v-icon>Print
                        <v-icon right></v-icon>
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                person_details:null,
                current_academic_year:null,
                frm:null,
            };
        },
        created() {
            this.awspath = localStorage.getItem("awspath");
            this.tenant = localStorage.getItem("EPS-tenant");
            console.log("uwws");
        },
        mounted(){
            this.frm = localStorage.getItem("setform_id");
            this.current_academic_year = localStorage.getItem("setay");

            const data = {
                      ay: this.current_academic_year,
                      form_id: this.frm,
                  };
                  localStorage.setItem("admission-ay", this.current_academic_year);
                  axios
                      .post("/Admission/get_application_form", data)
                      .then((res) => {
                          console.log("res", res.data);
                          if (res.data.status.code == "SUCCESS") {
                              this.person_details = res.data.person_details;
                              // (document.getElementById("one_view_form").style.pointerEvents =
                              //   "none"),
                              console.log(this.person_details);
                              this.printForm(this.person_details)
                              this.print_toggle = false;
                          } else {
                              console.log("Nah...");
                              this.person_details = null;
                              //error
                          }
                      })
                      .catch((error) => {
                          window.console.log(error);
                      })
                      .finally(() => {
                          //close loader
                      });
        },
        methods: {
            print() {
                setTimeout(function () {
                    window.print();
                }, 100);
            },
        },
    };
</script>

<style scoped>
    .sepcific_detail {
        text-decoration-line: underline;
        padding: 5px;
        text-align: justify;
        font-family: "Times New Roman";
    }
    .decoration {
        border-bottom: 1px solid black;
        padding: 5px;
        height: 30px;
        font-family: "Times New Roman";
    }
    @media print {
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }

        .textarea1 {
            background-color: red !important;
        }

        .pagebreak {
             page-break-before: always; 
            padding-top: 5px !important;
        }

        @page {
            size: A4;
            margin-top: 0;
            padding-top: none;
            /* size: 15in 15.5in; */
            size: 11.5in 16.5in;
        }

        @page :first {
            margin-top: 15mm;
        }
        li {
            font-size: larger !important;
            font-family: "Times New Roman";
        }
        .declaration_details {
            font-size: larger;
            padding: 30px;
            font-family: "Times New Roman";
        }
    }
    .photo {
        margin: 10px;
        margin-top: 15px;
        margin-right: 15px;
        float: right;
        font-family: "Times New Roman";
    }

    .declaration_details {
        font-size: larger;
        padding: 30px;
        font-family: "Times New Roman";
    }
    .stud_details {
        border-bottom: 1px solid black;
        font-family: "Times New Roman";
        height: 60px;
    }
    .stud_details1 {
        border-bottom: 1px solid black;
        font-family: "Times New Roman";
        height: 25px;
    }
    .stud_details2 {
        border-bottom: 1px solid black;
        font-family: "Times New Roman";
        height: 25px;
    }
    div.row {
        margin-top: 15px;
        font-family: "Times New Roman";
    }
    .row1 {
        margin-top: 0px;
        font-family: "Times New Roman";
    }
    li {
        margin-top: 25px;
        font-size: larger !important;
        font-family: "Times New Roman";
    }
</style>
